import get from 'lodash/get';
import { getURLParameterBykey } from 'yoda-core-components/lib/helpers/Utils/Utils';
import RestClient from '../RestClient/RestClient';
import { cstToUTC, getChannel } from '../Common/CommonHelper';
import {
    CATEGORY_BY_ID_URL,
    HOVER,
    VISUAL_NAVIGATION_DEPT_URL,
    L2_CAT,
    PRV_L2_CAT,
    JETLORE_URL,
    GALLERY_ZONE_URL,
    SKU_URL,
    COMPARE_PAGE_URL,
    CRITEO_URL,
    GALLERY_ZONE_INFO_URL,
    FOOTER_CAT,
    PRV_FOOTER_CAT,
} from './CatalogApiConstants';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { RestConfig, getHostConfig } from '../Common/RestConfig';
import { getCookie } from '../helpers/Cookies';
import { catIdRedirect } from './config';

/**
 * Function to fetch all root level departments.
 */
export const getCategoryById = (id) => {
    const categoryUrl = `${CATEGORY_BY_ID_URL}/${id}`;
    return RestClient.get(categoryUrl);
};

export const hoverPannel = (id) => {
    const params = {
        N: id,
    };
    let config = RestConfig.v1BrowseConfig('same-origin');
    config.url = HOVER;
    config.params = params;
    config = getHostConfig(config);
    return RestClient.get(config);
};

export const hoverPanelByURL = (url) => {
    let config = {
        url,
        excludeVersion: true,
        credentials: 'include',
        apiHost: apiHosts.browse,
    };

    config = getHostConfig(config);
    return RestClient.get(config).then((json) => json);
};

export const getPageTemplate = () => {
    const url = VISUAL_NAVIGATION_DEPT_URL;
    let config = RestConfig.v1BrowseConfig('same-origin');
    config.url = url;
    config = getHostConfig(config);
    return RestClient.get(config).then((json) => ({
        data: json.data,
    }));
};

// export const getGalleryDetailsById = (categoryId, params) => {
//     let config = RestConfig.v1SearchConfig();
//     config.url = `${categoryId}`;
//     config.params = params;
//     config = getHostConfig(config);
//
//     return RestClient.get(config)
//         .then(json => (json));
// };

export const getL2Category = () => {
    const url = L2_CAT;
    const context = RestClient.getContext();
    const channel = getChannel(context); // getting the channel type for IRIS
    const config = {
        url,
        excludeVersion: true,
        credentials: 'include',
        apiHost: __SERVER__ ? apiHosts.l2categoryapi : apiHosts.content,
        isXCloudHeaderRequired: true,
        channel,
    };

    /* istanbul ignore next */
    if (context.isPreview) {
        const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
        // Check for the Preview Environment Date
        config.previewDate = (dateValue || new Date()).toISOString();
        config.url = PRV_L2_CAT; // different end point to preveiew env
    }

    return RestClient.get(config).then((json) => json);
};

export const getFooterCategory = () => {
    const url = FOOTER_CAT;
    const context = RestClient.getContext();
    const channel = getChannel(context); // getting the channel type for IRIS
    const config = {
        url,
        excludeVersion: true,
        credentials: 'include',
        apiHost: apiHosts.content,
        isXCloudHeaderRequired: true,
        channel,
    };

    /* istanbul ignore next */
    if (context.isPreview) {
        const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
        // Check for the Preview Environment Date
        config.previewDate = (dateValue || new Date()).toISOString();
        config.url = PRV_FOOTER_CAT; // different end point to preveiew env
    }

    return RestClient.get(config).then((json) => json);
};

export const getJetloreProducts = (params) => {
    const config = {
        url: JETLORE_URL,
        credentials: 'include',
        params,
        external: true,
        host: '',
    };

    return RestClient.get(config);
};

export const getProductsByFinder = (params) => {
    let config = RestConfig.v1SearchConfig();
    config.url = 'f/filterContent/products';
    config.params = params;
    config = getHostConfig(config);

    return RestClient.get(config);
};

export const getZoneInfo = (params) => {
    let config = RestConfig.v1SearchConfig();
    config.url = GALLERY_ZONE_URL;
    config.params = params;
    config = getHostConfig(config);

    return RestClient.get(config).then((json) => json);
};

export const getSkuDetails = (params) => {
    const { payload } = params;
    let config = {
        url: `${SKU_URL}${params.payload.skus}`,
        credentials: 'include',
        undefined,
        version: payload && payload.version ? payload.version : '/v1',
        apiHost: apiHosts.browse,
    };

    config = getHostConfig(config);
    return RestClient.get(config).then((json) => json);
};

export const compareProducts = (params) => {
    const config = {
        apiHost: apiHosts.browse,
        params: { ppId: params },
        credentials: 'include',
        url: COMPARE_PAGE_URL,
        version: '/browse-aggregator/v1',
    };
    return RestClient.get(config).then((json) => json);
};

export const getCriteoProducts = (params) => {
    const config = {
        host: CRITEO_URL,
        url: params.path,
        excludeVersion: true,
        options: {
            jsonpCallback: 'json',
            jsonpCallbackFunction: 'hljson',
        },
    };
    return RestClient.jsonp(config);
};

const getPreviewConfig = (config) => {
    const context = RestClient.getContext();
    /* istanbul ignore next */
    if (context && context.isPreview) {
        config.customHeaders = {};
        const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
        // Check for the Preview Environment Date
        config.previewDate = (dateValue || new Date()).toISOString();
        const includeDraft = getURLParameterBykey('X-Include-Draft');
        const xDebug = getURLParameterBykey('X-Debug');

        if (includeDraft) {
            config.customHeaders['X-Include-Draft'] = includeDraft;
        }

        if (xDebug) {
            config.customHeaders['X-Debug'] = includeDraft;
        }
    }
    return config;
};

export const getGalleryStores = (params) => {
    const context = RestClient.getContext();
    let config = {
        url: '/storelocator',
        credentials: 'include',
        params,
        apiHost: __SERVER__ ? apiHosts.elb : apiHosts.search,
    };

    if (context.isPreview) {
        config.version = '/v1';
    } else {
        config.version = '/v1/search-service';
    }

    config = getHostConfig(config);
    config = getPreviewConfig(config);
    return RestClient.get(config).then((json) => json);
};

export const getGalleryDetailsById = (actionDetails, params) => {
    const {
        payload: {
            loc: { pathname },
            apiPath,
            isBloomReachV3Page = false,
        },
    } = actionDetails;
    const context = RestClient.getContext();

    let channel = 'desktop';
    if (get(context, 'deviceType.isMobile', false)) {
        channel = 'mobile';
    } else if (get(context, 'deviceType.isTablet', false)) {
        channel = 'tablet';
    }
    let config = {
        url: `${apiPath}`,
        credentials: 'include',
        params,
        apiHost: __SERVER__ ? apiHosts.elb : apiHosts.search,
        channel,
        enableRequestHeaderCookie: true,
    };
    // TODOAMP: Discuss
    config.url = config.url.replace(/^amp\//, '');

    if (context.isPreview || pathname.match(catIdRedirect.pattern)) {
        config.version = '/v1';
    } else {
        config.version = isBloomReachV3Page ? '/v3/search-service' : '/v1/search-service';
    }

    config = getHostConfig(config);
    config = getPreviewConfig(config);
    // logger.info('Payload of request invoking server side ', config);
    return RestClient.get(config).then((json) => json);
};

export const getZone = (params) => {
    const config = {
        url: `${GALLERY_ZONE_INFO_URL}`,
        credentials: 'include',
        params,
        version: '/v1',
        apiHost: __SERVER__ ? apiHosts.elb : apiHosts.search,
    };
    return RestClient.get(config).then((json) => json);
};

export const triggerBeacon = (params) => {
    const config = {
        url: params.url,
        host: '',
        external: true,
    };
    return RestClient.get(config);
};

export const getDynamicVisNavImageIds = (imgIdUrl) => {
    const config = {
        url: imgIdUrl,
        credentials: 'include',
        excludeVersion: true,
        apiHost: __SERVER__ ? apiHosts.elb : apiHosts.search,
    };
    return RestClient.get(config).then((json) => json);
};
